<ngx-loading-bar
  #loading
  color="#3AA36B"
  includeSpinner="false"
  height="3px"
></ngx-loading-bar>

<app-filter
  [textBtnNew]="textBtnNew"
  [urlBtnNew]="urlBtnNew"
  [typeComponent]="typeComponent"
  (expFilter)="translateFilter($event)"
></app-filter>

<app-pagination
  [currentUrl]="currentUrl"
  [total]="totalServices"
  (setPag)="setPag($event)"
></app-pagination>

<app-list
  [dataList]="dataList"
  [currentUrl]="currentUrl"
  [currencyColumn]="5"
></app-list>

<app-pagination
  [currentUrl]="currentUrl"
  [total]="totalServices"
  (setPag)="setPag($event)"
></app-pagination>
